/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { remap as remap$ } from "../lib/primitives.js";
import { safeParse } from "../lib/schemas.js";
import { Result as SafeParseResult } from "../types/fp.js";
import {
  AppSchemasLedgersLedgerCkerc20Contract,
  AppSchemasLedgersLedgerCkerc20Contract$inboundSchema,
  AppSchemasLedgersLedgerCkerc20Contract$Outbound,
  AppSchemasLedgersLedgerCkerc20Contract$outboundSchema,
} from "./appschemasledgersledgerckerc20contract.js";
import {
  AppSchemasLedgersLedgerIcrc1Metadata,
  AppSchemasLedgersLedgerIcrc1Metadata$inboundSchema,
  AppSchemasLedgersLedgerIcrc1Metadata$Outbound,
  AppSchemasLedgersLedgerIcrc1Metadata$outboundSchema,
} from "./appschemasledgersledgericrc1metadata.js";
import { SDKValidationError } from "./errors/sdkvalidationerror.js";

export type AppSchemasLedgersLedger = {
  ledgerCanisterId: string;
  snsRootCanisterId?: string | undefined;
  ckerc20OrchestratorId?: string | undefined;
  ckerc20Contract?: AppSchemasLedgersLedgerCkerc20Contract | undefined;
  icrc1Metadata: AppSchemasLedgersLedgerIcrc1Metadata;
};

/** @internal */
export const AppSchemasLedgersLedger$inboundSchema: z.ZodType<
  AppSchemasLedgersLedger,
  z.ZodTypeDef,
  unknown
> = z.object({
  ledger_canister_id: z.string(),
  sns_root_canister_id: z.string().optional(),
  ckerc20_orchestrator_id: z.string().optional(),
  ckerc20_contract: AppSchemasLedgersLedgerCkerc20Contract$inboundSchema
    .optional(),
  icrc1_metadata: AppSchemasLedgersLedgerIcrc1Metadata$inboundSchema,
}).transform((v) => {
  return remap$(v, {
    "ledger_canister_id": "ledgerCanisterId",
    "sns_root_canister_id": "snsRootCanisterId",
    "ckerc20_orchestrator_id": "ckerc20OrchestratorId",
    "ckerc20_contract": "ckerc20Contract",
    "icrc1_metadata": "icrc1Metadata",
  });
});

/** @internal */
export type AppSchemasLedgersLedger$Outbound = {
  ledger_canister_id: string;
  sns_root_canister_id?: string | undefined;
  ckerc20_orchestrator_id?: string | undefined;
  ckerc20_contract?:
    | AppSchemasLedgersLedgerCkerc20Contract$Outbound
    | undefined;
  icrc1_metadata: AppSchemasLedgersLedgerIcrc1Metadata$Outbound;
};

/** @internal */
export const AppSchemasLedgersLedger$outboundSchema: z.ZodType<
  AppSchemasLedgersLedger$Outbound,
  z.ZodTypeDef,
  AppSchemasLedgersLedger
> = z.object({
  ledgerCanisterId: z.string(),
  snsRootCanisterId: z.string().optional(),
  ckerc20OrchestratorId: z.string().optional(),
  ckerc20Contract: AppSchemasLedgersLedgerCkerc20Contract$outboundSchema
    .optional(),
  icrc1Metadata: AppSchemasLedgersLedgerIcrc1Metadata$outboundSchema,
}).transform((v) => {
  return remap$(v, {
    ledgerCanisterId: "ledger_canister_id",
    snsRootCanisterId: "sns_root_canister_id",
    ckerc20OrchestratorId: "ckerc20_orchestrator_id",
    ckerc20Contract: "ckerc20_contract",
    icrc1Metadata: "icrc1_metadata",
  });
});

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace AppSchemasLedgersLedger$ {
  /** @deprecated use `AppSchemasLedgersLedger$inboundSchema` instead. */
  export const inboundSchema = AppSchemasLedgersLedger$inboundSchema;
  /** @deprecated use `AppSchemasLedgersLedger$outboundSchema` instead. */
  export const outboundSchema = AppSchemasLedgersLedger$outboundSchema;
  /** @deprecated use `AppSchemasLedgersLedger$Outbound` instead. */
  export type Outbound = AppSchemasLedgersLedger$Outbound;
}

export function appSchemasLedgersLedgerToJSON(
  appSchemasLedgersLedger: AppSchemasLedgersLedger,
): string {
  return JSON.stringify(
    AppSchemasLedgersLedger$outboundSchema.parse(appSchemasLedgersLedger),
  );
}

export function appSchemasLedgersLedgerFromJSON(
  jsonString: string,
): SafeParseResult<AppSchemasLedgersLedger, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AppSchemasLedgersLedger$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AppSchemasLedgersLedger' from JSON`,
  );
}
